const USERNAME_REGEX = /^[a-zA-Z0-9]+((_|\.)?[a-zA-Z0-9])*$/;

export const isPassword = (string) => true;

export const isUsername = (string) =>
  string.length >= 3 && string.length <= 16 && USERNAME_REGEX.test(string);
